/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addReferenceableAndCopySubscribers} from '../api'

export const useMutationAddReferenceableAndCopySubscribers = createReactQueryMutationHook('addReferenceableAndCopySubscribers', addReferenceableAndCopySubscribers)
